workerWasCancelled